<template>
  <aside class="SocialIcons" v-if="currentUrl">
    Share
    <a :href="`https://www.linkedin.com/shareArticle?url=${encodeURI(currentUrl)}`" target="_blank">
      <img :src="linkedinSvg.src" alt="LinkedIn">
    </a>
    <a :href="`https://www.facebook.com/sharer/sharer.php?u=${encodeURI(currentUrl)}`" target="_blank">
      <img :src="facebookSvg.src" alt="Facebook">
    </a>
    <a :href="`https://twitter.com/intent/tweet?url=${encodeURI(currentUrl)}`" target="_blank">
      <img :src="twitterSvg.src" alt="Twitter">
    </a>
  </aside>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue'

import linkedinSvg from '~/assets/social-icons/linkedin.svg'
import facebookSvg from '~/assets/social-icons/facebook.svg'
import twitterSvg from '~/assets/social-icons/twitter.svg'

const currentUrl = ref()

onBeforeMount(function () {
  currentUrl.value = document.location.href
})
</script>

<style scoped>
.SocialIcons {
  border-top: 2px solid var(--hairline-color);
  padding-top: var(--spacing-8);
  display: flex;
  align-items: center;
  gap: var(--spacing-5);
  font-size: var(--font-size-1);
}
</style>
